import { defineQuiz } from "./_schema";
import { igniteQuiz } from "./ignite";

/**
 * QUIZ-V6-AL -- tracking-isolated duplicate of the ignite quiz (quiz-v6) for
 * AppLovin traffic.
 *
 * Analytics in this system is keyed by SLUG, not URL (admin funnel,
 * quiz_submissions.quiz_slug, Klaviyo event/profile props). AppLovin-sourced
 * traffic to the quiz-v6 funnel needs to be attributable separately, so we
 * mount an identical quiz under a distinct slug and publish it at
 * /pages/quiz-v6-al. Same on-screen experience, separate row everywhere in
 * our own analytics. Sibling of quiz-v6-gl (the Google duplicate).
 *
 * This is a THIN RE-EXPORT of ignite: it spreads `igniteQuiz` and overrides
 * only `id` / `slug` (and drops the Intelligems experiment). The two quizzes
 * share the same `questions` array, `classifier`, and `deriveProfile` BY
 * REFERENCE, so they can never drift -- any future edit to ignite's content
 * propagates here automatically. If the two are ever meant to diverge, that
 * becomes a deliberate change (stop spreading, fork the fields).
 *
 * The `experiment` block is intentionally dropped (set undefined). Rationale:
 *  - Rendering is identical to ignite's control: `visibleQuestions` /
 *    `visibleMeta` treat a null variant as "control", ignite has no
 *    variant-tagged questions, and its testimonial is control-tagged -- so the
 *    control-flow render equals ignite's default render.
 *  - Without `experiment`, the widget never touches `window.igData` (rule #24),
 *    so there is no ~1.5s Intelligems resolver latency on this paid-traffic
 *    page, and AppLovin traffic does not contaminate the MM-0064 test population.
 * Add the `experiment` block back (one line) if the same A/B is ever wanted on
 * AppLovin traffic.
 *
 * See docs/specs/2026-07-22-applovin-tracking-duplicates-design.md.
 */
export const quizV6AlQuiz = defineQuiz({
  ...igniteQuiz,
  id: "quiz-v6-al",
  slug: "quiz-v6-al",
  experiment: undefined,
});
